import { Link } from "gatsby"
import parse from "html-react-parser"
import React, { useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import Tilt from "react-parallax-tilt"
import Fade from "react-reveal/Fade"
import Links from "../../components/common/links"
import RevDemoPage from "../../pages/demo"
import "./../../styles/component/cta.scss"
import FormBuilder from "./FormBuilder/Form-Builder"
import SVGIcon from "./SVGIcon"
import Buttons from "./button"

function CTA(props) {
  var delayCount = 0
  const linkProp = props.signupPopup
    ? {}
    : { link: props.data[0].primaryButtonLink }

  const ctaImage =
    props.data[0]?.card &&
    props.data[0]?.card.length &&
    props.data[0]?.card[0]?.image &&
    props.data[0]?.card[0]?.image.length &&
    !props.blogCTA &&
    props.data[0].type !== "Download"
      ? true
      : false

  const ctaDescriptionLink =
    props.data[0].type === "Link" &&
    props.data[0]?.card &&
    props.data[0]?.card.length &&
    props.data[0]?.card[0].cardDescription
      ? true
      : false

  const secondaryBtn = props.isSecondaryBtn ? true : false

  const [isOpenDemoPopup, setIsOpenDemoPopup] = useState(false)

  return (
    <>
      {isOpenDemoPopup && (
        <RevDemoPage isOnlyForm onClose={() => setIsOpenDemoPopup(false)} />
      )}
      <Container
        className={`Layout-container${
          props?.containerClass ? "-big" : ""
        } position-relative ${props.className}`}
      >
        {props.newTag && (
          <>
            <SVGIcon name="home/New-new" className="position-absolute new" />
          </>
        )}
        {props.data[0].type === "DoubleCardPopup" ||
        props.data[0].type === "DoubleCard" ? (
          <div
            className={`d-flex flex-wrap justify-content-between double-cta-cards row-gap-24 ${props.data[0].theme}`}
          >
            <div
              className={`first-cta-card d-flex flex-wrap row-gap-24 justify-content-evenly`}
            >
              <Col lg={5} className="">
                <div
                  className={`heading down-to-up-1 ${ctaDescriptionLink &&
                    "text-center"}`}
                  style={{
                    maxWidth: props.maxHeadingWidth
                      ? props.maxHeadingWidth
                      : "100%",
                  }}
                >
                  <span className="dspnone">{delayCount++}</span>
                  {parse(props.data[0].heading?.html)}
                </div>
                {props.data[0].description?.html && (
                  <div
                    className={`description ${props.data[0].type === "Card" &&
                      "p18 mb30"} down-to-up-2`}
                    style={{
                      maxWidth: props.maxDescriptionWidth
                        ? props.maxDescriptionWidth
                        : "100%",
                    }}
                  >
                    <span className="dspnone">{delayCount++}</span>
                    {parse(props.data[0].description?.html)}
                  </div>
                )}
              </Col>
              <Col
                lg={3}
                className="d-flex flex-wrap justify-content-center align-items-center gap-8"
              >
                {props.data[0].type === "DoubleCardPopup" ? (
                  props.openPopUp ? (
                    <Buttons
                      theme={
                        props.data[0].theme === "dark" ||
                        props.data[0].theme === "customDark" ||
                        props.data[0].theme === "linearGradient"
                          ? `primary${
                              props.newButton ? "-new white-new" : ""
                            } white w-100`
                          : `secondary${props.newButton ? "-new" : ""} w-100`
                      }
                      arrow
                      onClick={() => props.openPopUp()}
                      text={props.data[0].primaryButtonText}
                    />
                  ) : (
                    <Buttons
                      theme={
                        props.data[0].theme === "dark" ||
                        props.data[0].theme === "customDark" ||
                        props.data[0].theme === "linearGradient"
                          ? `primary${
                              props.newButton ? "-new white-new" : ""
                            } white w-100`
                          : `secondary${props.newButton ? "-new" : ""} w-100`
                      }
                      arrow
                      signupPopup
                      text={props.data[0].primaryButtonText}
                      disallowCommonDomains={props.disallowCommonDomains}
                    />
                  )
                ) : (
                  <Buttons
                    theme={
                      props.data[0].theme === "dark" ||
                      props.data[0].theme === "customDark" ||
                      props.data[0].theme === "linearGradient"
                        ? `primary${
                            props.newButton ? "-new white-new" : ""
                          } white w-100`
                        : `secondary${props.newButton ? "-new" : ""} w-100`
                    }
                    link={props.data[0].primaryButtonLink}
                    text={props.data[0].primaryButtonText}
                    newTab={
                      props.data[0].primaryLinkInNewTab === "Yes" ? true : false
                    }
                  />
                )}
                {props.data[0].secondaryButtonText &&
                  props.data[0].secondaryButtonLink && (
                    <Buttons
                      theme={`secondary${
                        props.newButton ? "-new white-new" : ""
                      } w-100`}
                      link={props.data[0].secondaryButtonLink}
                      text={props.data[0].secondaryButtonText}
                      newTab={
                        props.data[0].primaryLinkInNewTab === "Yes"
                          ? true
                          : false
                      }
                    />
                  )}
              </Col>
            </div>
            <div
              lg={4}
              className="second-cta-card text-center d-flex align-items-center justify-content-center"
            >
              <div className="bg-image w-100">
                <div className="inner-cover mx-auto">
                  <p className="p24 font-roboto fw-bold">
                    {props.data[0].card[0].text[0]}
                  </p>
                  <div>
                    <p className="d-inline font-roboto fw-bold symbol">
                      {props.data[0].card[0].subtext[0]}
                    </p>
                    <p className="d-inline font-roboto fw-bold number">
                      {props.data[0].card[0].subtext[1]}
                    </p>
                  </div>
                  <p className="p16 m-0">{props.data[0].card[0].text[1]}</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="br-10 cta-wrapper"
            style={{
              background:
                props.data[0].theme === "dark" &&
                props.newDesign &&
                "linear-gradient(180deg, #3F0B68 0%, #170425 100%)",
            }}
          >
            <div
              className={`p-0 ${props.newDesign && "design-2023"} ${
                props.blogCTA ? "blog-cta" : "CTA"
              } ${props.data[0].theme} ${props.data[0]?.tag &&
                "tag-available"}`}
              style={{
                maxWidth: props.maxBoxWidth ? props.maxBoxWidth : "100%",
                backgroundColor:
                  (props.data[0].theme === "customLight" ||
                    props.data[0].theme === "customDark") &&
                  props.data[0].customBackgroundColor,
                backgroundImage:
                  props.data[0].theme === "linearGradient" &&
                  props.data[0].customBackgroundColor,
              }}
            >
              <div
                className={`${props.blogCTA && "blog-cta"} ${props.bgPattern &&
                  "bg-pattern"} cta-child ${ctaImage && "cta-image"}`}
              >
                <Row
                  style={{
                    maxWidth: props.maxRowWidth && props.maxRowWidth,
                  }}
                  className={`${props.data[0].type === "Card" &&
                    "cta-card-row"} ${ctaImage &&
                    "justify-content-center"}  cta-align-center`}
                >
                  {props.data[0].type === "Subscribe" ? (
                    <>
                      <Col lg={props.lgLeft ? props.lgLeft : 5}>
                        <div className="left">
                          {props.newsletter && (
                            <div className="svg-wrapper">
                              <SVGIcon name="Newsletter" />
                            </div>
                          )}
                          {props.data[0].tag && (
                            <div className="p14">
                              <p className="active">{props.data[0].tag}</p>
                            </div>
                          )}
                          <div
                            className="heading"
                            style={{
                              maxWidth: props.maxHeadingWidth
                                ? props.maxHeadingWidth
                                : "100%",
                            }}
                          >
                            {parse(props.data[0].heading?.html)}
                          </div>
                          {props.data[0].description?.html && (
                            <div
                              className="description"
                              style={{
                                maxWidth: props.maxDescriptionWidth
                                  ? props.maxDescriptionWidth
                                  : "100%",
                              }}
                            >
                              {parse(props.data[0].description?.html)}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col lg={props.lgRight ? props.lgRight : 5}>
                        <FormBuilder
                          formClassName="cta-form"
                          errorClassName="error-message"
                          inputClassName="email"
                          inputErrorClassName="error-active"
                          buttonText={
                            props.buttonText ? props.buttonText : "SUBSCRIBE"
                          }
                          buttonClassName={
                            props.buttonClassName
                              ? props.buttonClassName
                              : "primary white"
                          }
                          type="subscribe"
                          path={props.path ? props.path : "subscription"}
                        />

                        {props.data[0].isLinkVisible === "Yes" && (
                          <div className="social-wrapper">
                            {props.data[0].listenLinkText && (
                              <p className="social-text">
                                {props.data[0].listenLinkText}
                              </p>
                            )}
                            <div className="social-icons-wrapper d-flex">
                              <Links
                                className="icons"
                                items={props.data[0].links[0]}
                                iconOnly
                                name
                              />
                            </div>
                          </div>
                        )}
                      </Col>
                    </>
                  ) : (
                    <>
                      <Col
                        lg={props.lgLeft ? props.lgLeft : 6}
                        className={`left-col ${props.data[0].type === "Card" &&
                          "d-flex align-items-center"} ${ctaImage && "d-flex"}`}
                        style={props.leftStyles}
                      >
                        <Col lg={ctaImage ? 7 : 12}>
                          <div className="left">
                            {props.data[0].tag && (
                              <div className="p14">
                                <p className="active">{props.data[0].tag}</p>
                              </div>
                            )}
                            <div
                              className={`heading down-to-up-1 ${ctaDescriptionLink &&
                                "text-center"}`}
                              style={{
                                maxWidth: props.maxHeadingWidth
                                  ? props.maxHeadingWidth
                                  : "100%",
                              }}
                            >
                              <span className="dspnone">{delayCount++}</span>
                              {parse(props.data[0].heading?.html)}
                            </div>
                            {props.data[0].description?.html && (
                              <>
                                <div
                                  className={`${
                                    props.blogCTA
                                      ? "blog-cta-desc"
                                      : "description"
                                  } ${props.data[0].type === "Card" &&
                                    "p18 mb30"} down-to-up-2`}
                                  style={{
                                    maxWidth: props.maxDescriptionWidth
                                      ? props.maxDescriptionWidth
                                      : "100%",
                                  }}
                                >
                                  <span className="dspnone">
                                    {delayCount++}
                                  </span>
                                  {parse(props.data[0].description?.html)}
                                </div>

                                {props.blogCTA && (
                                  <img
                                    className="blog-cta-rating-img"
                                    src={props.data[0].card[0].picture[0].url}
                                    alt="rating-img"
                                  />
                                )}
                              </>
                            )}
                            {props.data[0].type === "Card" && (
                              <>
                                <span className="dspnone">{delayCount++}</span>
                                <div className="buttons-left d-flex down-to-up-2">
                                  {props.data[0].type !== "PopUp" &&
                                    props.data[0].type !== "UploadPopup" && (
                                      <Buttons
                                        theme={
                                          props.data[0].theme === "dark" ||
                                          props.data[0].theme ===
                                            "customDark" ||
                                          props.data[0].theme ===
                                            "linearGradient"
                                            ? `primary${
                                                props.newButton ? "-new" : ""
                                              } white`
                                            : `secondary${
                                                props.newButton ? "-new" : ""
                                              }`
                                        }
                                        style={{ border: "none" }}
                                        formOneAPI={props.formOneAPI}
                                        formTwoAPI={props.formTwoAPI}
                                        signupPopup={props.signupPopup}
                                        {...linkProp}
                                        text={props.data[0].primaryButtonText}
                                        newTab={
                                          props.data[0].primaryLinkInNewTab ===
                                          "Yes"
                                            ? true
                                            : false
                                        }
                                        disallowCommonDomains={
                                          props.disallowCommonDomains
                                        }
                                      />
                                    )}

                                  {props.data[0].secondaryButtonText &&
                                    props.data[0].secondaryButtonLink && (
                                      <Buttons
                                        theme={
                                          props.data[0].theme === "dark" ||
                                          props.data[0].theme ===
                                            "customDark" ||
                                          props.data[0].theme ===
                                            "linearGradient"
                                            ? `secondary${
                                                props.newButton ? "-new" : ""
                                              }`
                                            : `primary${
                                                props.newButton ? "-new" : ""
                                              } white`
                                        }
                                        popupDemo={props.popupDemo}
                                        link={
                                          props.popupDemo
                                            ? false
                                            : props.data[0].secondaryButtonLink
                                        }
                                        text={props.data[0].secondaryButtonText}
                                        newTab={
                                          props.data[0].primaryLinkInNewTab ===
                                          "Yes"
                                            ? true
                                            : false
                                        }
                                      />
                                    )}
                                </div>
                              </>
                            )}
                          </div>
                        </Col>
                        {ctaDescriptionLink && (
                          <div className="description-link d-flex justify-content-center">
                            <Fade top delay={120} duration="1000">
                              <SVGIcon
                                name="cta/curvedWhiteArrow"
                                className="curved-arrow left d-dsk"
                              />
                              <Link to={props.data[0]?.card[0].slug}>
                                <p className="mt24 text-pink description text-center">
                                  {props.data[0]?.card[0].cardDescription}
                                </p>
                              </Link>
                              <SVGIcon
                                name="cta/curvedWhiteArrow"
                                className="curved-arrow right d-dsk"
                              />
                            </Fade>
                          </div>
                        )}
                        {ctaImage && !props.blogCTA && (
                          <Col lg={5} className="cta-image-card">
                            <div className="img-wrapper mx-auto">
                              <img
                                src={props.data[0].card[0].image[0].url}
                                alt="cta-image"
                                className="w-100"
                              />
                            </div>
                          </Col>
                        )}
                      </Col>
                      {!ctaDescriptionLink && (
                        <Col
                          lg={props.lgRight ? props.lgRight : 3}
                          style={props.rightStyles}
                          className="right-col d-flex align-items-center justify-content-center"
                        >
                          {props.data[0].type !== "Card" ? (
                            <div className="right w-100 text-center">
                              {props.data[0].type === "Download" && (
                                <Buttons
                                  theme={
                                    props.data[0].theme === "dark" ||
                                    props.data[0].theme === "customDark" ||
                                    props.data[0].theme === "linearGradient"
                                      ? `primary${
                                          props.newButton
                                            ? "-new white-new"
                                            : ""
                                        } white`
                                      : `secondary${
                                          props.newButton ? "-new" : ""
                                        }`
                                  }
                                  text={props.data[0].card[0].subtext[0]}
                                  file={props.data[0].card[0].image[0]?.url}
                                  fileName={props.data[0].card[0].title[0]}
                                  downloadFile
                                />
                              )}
                              {props.data[0].type === "PopUp" ? (
                                props.openPopUp ? (
                                  <Buttons
                                    theme={
                                      props.data[0].theme === "dark" ||
                                      props.data[0].theme === "customDark" ||
                                      props.data[0].theme === "linearGradient"
                                        ? `primary${
                                            props.newButton
                                              ? "-new white-new"
                                              : ""
                                          } white`
                                        : `secondary${
                                            props.newButton ? "-new" : ""
                                          }`
                                    }
                                    arrow
                                    onClick={() => props.openPopUp()}
                                    text={props.data[0].primaryButtonText}
                                  />
                                ) : (
                                  <Buttons
                                    theme={
                                      props.data[0].theme === "dark" ||
                                      props.data[0].theme === "customDark" ||
                                      props.data[0].theme === "linearGradient"
                                        ? `primary${
                                            props.newButton
                                              ? "-new white-new"
                                              : ""
                                          } white`
                                        : `secondary${
                                            props.newButton ? "-new" : ""
                                          }`
                                    }
                                    arrow
                                    formOneAPI={props.formOneAPI}
                                    formTwoAPI={props.formTwoAPI}
                                    signupPopup
                                    text={props.data[0].primaryButtonText}
                                    disallowCommonDomains={
                                      props.disallowCommonDomains
                                    }
                                  />
                                )
                              ) : null}
                              {props.data[0].type === "UploadPopup" && (
                                <Buttons
                                  theme={
                                    props.data[0].theme === "dark" ||
                                    props.data[0].theme === "customDark" ||
                                    props.data[0].theme === "linearGradient"
                                      ? "primary white"
                                      : "secondary"
                                  }
                                  arrow
                                  UploadPopup
                                  text={props.data[0].primaryButtonText}
                                />
                              )}

                              {props.data[0].type !== "PopUp" &&
                                props.data[0].type !== "UploadPopup" && (
                                  <Fade
                                    bottom
                                    delay={(delayCount + 1) * 130}
                                    duration="1000"
                                  >
                                    <span className="dspnone">
                                      {delayCount++}
                                    </span>
                                    {props.data[0].primaryButtonText ? (
                                      props.blogCTA ? (
                                        <Buttons
                                          theme="primary-pink w-100"
                                          link={props.data[0].primaryButtonLink}
                                          text={props.data[0].primaryButtonText}
                                          newTab={
                                            props.data[0]
                                              .primaryLinkInNewTab === "Yes"
                                              ? true
                                              : false
                                          }
                                        />
                                      ) : (
                                        <Buttons
                                          theme={
                                            props.data[0].theme === "dark" ||
                                            props.data[0].theme ===
                                              "customDark" ||
                                            props.data[0].theme ===
                                              "linearGradient"
                                              ? `primary${
                                                  props.newButton
                                                    ? `-new${
                                                        props.isPrimaryPink
                                                          ? "-pink"
                                                          : ` white-new`
                                                      }`
                                                    : ""
                                                } white`
                                              : `secondary${
                                                  props.newButton ? "-new" : ""
                                                }`
                                          }
                                          // arrow
                                          link={props.data[0].primaryButtonLink}
                                          text={props.data[0].primaryButtonText}
                                          newTab={
                                            props.data[0]
                                              .primaryLinkInNewTab === "Yes"
                                              ? true
                                              : false
                                          }
                                        />
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </Fade>
                                )}

                              {props.data[0].secondaryButtonText &&
                                props.data[0].secondaryButtonLink &&
                                (secondaryBtn ? (
                                  <Fade
                                    bottom
                                    delay={(delayCount + 1) * 150}
                                    duration="1000"
                                  >
                                    <Buttons
                                      theme={`secondary${
                                        props.newButton ? "-new " : ""
                                      } white-new down-to-up-4 sec-btn`}
                                      popupDemo={props.popupDemo}
                                      link={
                                        props.popupDemo
                                          ? false
                                          : props.data[0].secondaryButtonLink
                                      }
                                      text={props.data[0].secondaryButtonText}
                                    />
                                  </Fade>
                                ) : (
                                  <div
                                    className="second-link a12"
                                    onClick={() =>
                                      props.popupDemo &&
                                      setIsOpenDemoPopup(true)
                                    }
                                  >
                                    <Link
                                      to={
                                        props.popupDemo
                                          ? false
                                          : props.data[0].secondaryButtonLink
                                      }
                                      className="link"
                                    >
                                      {props.data[0].secondaryButtonText}
                                      <SVGIcon
                                        name="hypertext-arrow-right"
                                        className="arrow-right"
                                      />
                                    </Link>
                                  </div>
                                ))}

                              {props.data[0].secondaryButtonText &&
                                !props.data[0].secondaryButtonLink && (
                                  <div className="secondary-text p16">
                                    <p>{props.data[0].secondaryButtonText}</p>
                                  </div>
                                )}
                            </div>
                          ) : (
                            <div className="cta-card-wrap d-flex flex-wrap down-to-up-2">
                              {props.data[0].card.map(cData => (
                                <>
                                  <span className="dspnone">
                                    {delayCount++}
                                  </span>
                                  <Link to={cData.slug} className="no-deco">
                                    <Tilt
                                      className="parallax-effect-glare-scale"
                                      perspective={800}
                                      scale={1.02}
                                    >
                                      <div className="cta-card text-grey br-10 prelative">
                                        <h5 className="fw-bold">
                                          {cData.title[0]}
                                        </h5>
                                        <p className="p16 card-desc">
                                          {cData.subtext[0]}
                                        </p>
                                        <p className="link-text position-absolute">
                                          {cData.cardName}{" "}
                                          {props.isLinkTextWithArrow && (
                                            <SVGIcon
                                              name="hypertext-arrow-right"
                                              className="arrow-right"
                                            />
                                          )}
                                        </p>
                                        <SVGIcon
                                          name="carousel-right"
                                          className="arrow-icon position-absolute"
                                        />
                                      </div>
                                    </Tilt>
                                  </Link>
                                </>
                              ))}
                            </div>
                          )}
                        </Col>
                      )}
                    </>
                  )}
                </Row>
              </div>
            </div>
          </div>
        )}
      </Container>
    </>
  )
}

export default CTA
